module.exports = __webpack_public_path__ + "img/国家石油和化工网.4ba5b611.png";